"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const SearchHelpBox = ({ classes, anchorEl, onClose }) => (<material_1.Popover id="search-help-popover" open anchorEl={anchorEl} onClose={onClose} anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
    }} transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
    }}>
    <div className={classes.searchHelpContainer}>
      <material_1.Typography className={classes.searchHelpTitle} variant="h6">
        Search Tips
      </material_1.Typography>
      <material_1.Typography className={classes.searchHelpSubtitle} variant="subtitle1">
        Searching for Amounts
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {`Amount searches that start with '-' or '+' will restrict to expenses or income`}
      </material_1.Typography> {/* eslint-disable-line */}
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"23" will search for 23.00 or -23.00'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"-23.50" will search for -23.50'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"-23ish" will search for values roughly around -23.00'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"~-23" will also search for values roughly around -23.00'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"+>1000" will search for income transactions greater than 1000.00'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"+<1000" will search for income transactions less than 1000.00'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"-&50 .to. 100" will search for expense transactions between 50.00 and 100.00'}
      </material_1.Typography>
      <material_1.Typography className={classes.searchHelpSubtitle} variant="subtitle1">
        Searching for Dates
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"02/03/2020" will search for transactions dated 02/03/2020'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"02/03/2020ish" will search for transactions dated around 02/03/2020'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'">02/03/2020" will search for transactions on or past 02/03/2020'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"<02/03/2020" will search for transactions on or before 02/03/2020'}
      </material_1.Typography>
      <material_1.Typography className={classes.helpText} variant="body2">
        {'"&02/03/2020 .to. 03/10/2020" will search for transactions between 02/03 and 03/10/2020'}
      </material_1.Typography>

    </div>
  </material_1.Popover>);
exports.default = SearchHelpBox;
